<template>
  <dr-column :class="isPageCenter?'no-data':''" v-if="dataText!=''" justifyContent="center" alignItems="center">
    <van-image :src="imgs" width="87" />
    <div class="no-data-text">{{dataText}}</div>
  </dr-column>
</template>

<script>
export default {
  props: {
    dataText: {
      type: String,
      default: ""
    },
    isPageCenter:{
      type: Boolean,
      default: false
    },
    imgs:{
      type:String,
      default:"static/imgs/no-data.png",
    }
  }
}
</script>

<style scoped>
.no-data {
  position: absolute;
  top: 45%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 1000;
  min-width: 100px;
  min-height: 100px;
  border-radius: 5px;
}
.no-data-text {
  color: #666666;
  font-size: 13px;
  margin-top: 11px;
}
</style>


// WEBPACK FOOTER //
// src/components/noData/index.vue